import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { AuthStore, AUTH_STORE, CurrentUserModel, TipoUsuario } from '../Store/Auth';

interface IProps {
    history?: any;
    location: any;
    [AUTH_STORE]: AuthStore;
}

interface IState {
    redirect: string;
}

const withAuth = <P extends object>(Component: React.ComponentType<P>) => {
    @inject(AUTH_STORE)
    @observer
  class WithAuth extends React.Component<P & IProps, IState> {
      constructor(props: P & IProps) {
        super(props);
        this.state = {
          redirect: ''
        };
      }

        setPath = (user: CurrentUserModel) => {
          switch (user.tipoUsuario) {
            case TipoUsuario.Aluno:
              this.setState({ redirect: 'aluno' });
              break;
            case TipoUsuario.Professor:
              this.setState({ redirect: 'professor' });
              break;
            case TipoUsuario.Funcionario:
              this.setState({ redirect: 'funcionario' });
              break;
            default:
              this.setState({ redirect: '' });
              break;
          }
        }

        componentDidUpdate = async () => {
          const authStore = this.props[AUTH_STORE];

          if (authStore.isTokenExpired())
            await authStore.renewToken();
        }

        componentDidMount = async () => {
          const authStore = this.props[AUTH_STORE];
          await authStore.login();

          if (authStore.isLoggedIn()) this.setPath(authStore.currentUser);
        }

        render() {
          return <Component {...this.props} {...this.state} />;
        }
    }

    return WithAuth;
};

export default withAuth;